import React, { useEffect, useState, useRef, useCallback } from "react";
import { Modal, Form, Row, Col } from "react-bootstrap";
import { fetchEventDetails, fetchEventMap, GetUserDataForUpdate, PopulateEventData, saveFilterDetails, updateFilterDetails } from "./services/api";
import { SeatsOptions } from "./Enum";
import ScreenLoading from "./ScreenLoading";

export default function EventFilterModal({ show, onHide, onApplyFilter, eventMeta = {}, hasFilter = false, }) {
    const [loading, setLoading] = useState(false);
    const requestSeqRef = useRef(0);

    // normalized event data used by UI
    const [eventData, setEventData] = useState({
        EventName: "",
        EventVenue: "",
        EventDate: "",
        EventLink: "",
        EventID: "",
        price: [],
        sections: [],
        ticketType: [],
        mapImage: "",
        EventInfoID: eventMeta.EventInfoID,
        savedFilter: null,
    });

    const [sections, setSections] = useState([]);
    const [sectionIndex, setSectionIndex] = useState([]);
    const [selectedSec, setSelectedSec] = useState([]);
    const [secArea, setSecArea] = useState([]);
    const [price, setPrice] = useState([]);
    const [minPrice, setMinPrice] = useState("");
    const [maxPrice, setMaxPrice] = useState("");

    const [isManual, setIsManual] = useState(false);
    const [manualMinPrice, setManualMinPrice] = useState("");
    const [manualMaxPrice, setManualMaxPrice] = useState("");

    const [minSeats, setMinSeats] = useState("");
    const [ticketType, setTicketType] = useState([]);
    const [selectedType, setSelectedType] = useState("0");
    const [filter, setFilter] = useState([]); // filters added locally (array with single object)
    const [errorMsg, setErrorMsg] = useState("");
    const [selectedDropdown, setSelectedDropdown] = useState("");


    // Helper: normalize API into our eventData structure
    const normalizeResponse = (apiData = {}, mapSvg = "", savedFilter = null, infoId = null) => {
        return {
            EventName: apiData.eventName || "",
            EventVenue: apiData.eventVenue || "",
            EventDate: apiData.eventDate || "",
            EventLink: apiData.eventUrl || "",
            EventID: apiData.eventID || "",
            price: Array.isArray(apiData.price) ? apiData.price : (typeof apiData.price === "string" ? apiData.price.split(",").map(Number).filter(n => !isNaN(n)) : []),
            sections: Array.isArray(apiData.sectiondict) ? apiData.sectiondict : Object.values(apiData.sectiondict || {}),
            ticketType: Array.isArray(apiData.ticketType) ? apiData.ticketType : (apiData.ticketType ? [apiData.ticketType] : []),
            mapImage: mapSvg || "",
            EventInfoID: infoId || null,
            savedFilter: savedFilter || null,
        };
    };

    // const handleSections = (event) => {
    //     const target = event.target;
    //     if (target.classList.contains('selected-sec')) {
    //         return;
    //     }
    //     else {
    //         if (target.tagName.toLowerCase() === "path") {
    //             const target_d = target.getAttribute('d');
    //             var startValueTemp = Number(target_d.split(' ')[0].split('M')[1]);
    //             if (isNaN(startValueTemp)) {
    //                 console.warn("Invalid path data: startValueTemp is NaN");
    //                 return;
    //             }
    //             let d;
    //             let path_ID;
    //             if (true) {
    //                 var startValue = "M" + startValueTemp.toFixed(2);
    //                 var all_path = checker(startValue);
    //                 if (all_path === "fix value") {
    //                     startValue = "M" + startValueTemp.toFixed(1);
    //                     all_path = checker(startValue);
    //                 }
    //                 if (all_path.length === 1) {
    //                     var temparr = target_d.split(' ');
    //                     //var firstVal = "M"+Number(temparr[0].split('M')[1]).toFixed(2);
    //                     //var secondVal = Number(temparr[1]).toFixed(2);
    //                     var searchValue = `${startValue}`;
    //                     if (Array.isArray(all_path) || all_path.forEach) {
    //                         all_path.forEach(path => {
    //                             d = path.getAttribute("d");
    //                             if (d && d.startsWith(searchValue)) {
    //                                 path_ID = path.getAttribute('id');
    //                                 console.log("Matched path:", path_ID);
    //                             }
    //                         });
    //                     }
    //                 }
    //                 else if (all_path.length > 1) {
    //                     var temparr = target_d.split(' ');
    //                     //var firstVal = "M"+Number(temparr[0].split('M')[1]).toFixed(2);
    //                     var firstVal = startValue;
    //                     var secondVal = Number(temparr[1]).toFixed(2);
    //                     var searchValue = `${firstVal},${secondVal}`;
    //                     all_path = checker(searchValue);
    //                     if (all_path === "fix value") {
    //                         secondVal = Number(temparr[1]).toFixed(1);
    //                         searchValue = `${firstVal},${secondVal}`;
    //                         all_path = checker(searchValue);
    //                     }
    //                     if (Array.isArray(all_path) || all_path.forEach) {
    //                         all_path.forEach(path => {
    //                             d = path.getAttribute("d");
    //                             if (d && d.startsWith(searchValue)) {
    //                                 path_ID = path.getAttribute('id');
    //                                 console.log("Matched path:", path_ID);
    //                             }
    //                         });
    //                     }
    //                     else {
    //                         var firstVal = "M" + Number(temparr[0].split('M')[1]).toFixed(2);
    //                         var secondVal_2 = Number(temparr[1]).toFixed(1);
    //                         var searchValue_2 = `${firstVal},${secondVal_2}`;
    //                         all_path.forEach(path => {
    //                             d = path.getAttribute("d");
    //                             if (d && d.startsWith(searchValue_2)) {
    //                                 path_ID = path.getAttribute('id');
    //                                 console.log("Matched path:", path_ID);
    //                             }
    //                         });
    //                     }
    //                 }
    //                 else {
    //                     const startValue_2 = "M" + startValueTemp.toFixed(1);
    //                     const all_path_2 = checker(startValue_2);
    //                     all_path_2.forEach(path => {
    //                         d = path.getAttribute("d");
    //                         if (d && d.startsWith(startValue_2)) {
    //                             path_ID = path.getAttribute('id');
    //                             console.log(path);
    //                             console.log("Matched path:", path_ID);
    //                         }
    //                     });
    //                 }
    //             }
    //             const selectedPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
    //             selectedPath.setAttribute("d", d);
    //             selectedPath.setAttribute("fill", "rgba(99, 102, 241, 1)");
    //             selectedPath.setAttribute("fill-rule", "evenodd");
    //             selectedPath.setAttribute("class", "selected-sec");
    //             selectedPath.setAttribute("data-sec", path_ID);
    //             document.getElementById("section-map-outline-container").firstChild.append(selectedPath);
    //             if (!selectedSec.includes(path_ID)) {
    //                 setSelectedSec(prev => [...prev, path_ID]);
    //                 const idx = sections.indexOf(path_ID);
    //                 if (idx !== -1) {
    //                     setSecArea(prev => [...prev, idx]);
    //                 }
    //             }

    //             // handleSelectSection_Map(path_ID);
    //         }
    //         else if (target.tagName.toLowerCase() === "text") {
    //             const temp_value = target.textContent;
    //             const container = document.getElementById('background-container');
    //             const exact_match = document.getElementById(temp_value);
    //             if (!selectedSec.includes(temp_value)) {
    //                 if (exact_match) {
    //                     const path_ID = exact_match.getAttribute('id');
    //                     const d = exact_match.getAttribute('d');
    //                     const selectedPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
    //                     selectedPath.setAttribute("d", d);
    //                     selectedPath.setAttribute("fill", "rgba(99, 102, 241, 1)");
    //                     selectedPath.setAttribute("fill-rule", "evenodd");
    //                     selectedPath.setAttribute("class", "selected-sec");
    //                     selectedPath.setAttribute("data-sec", path_ID);
    //                     document.getElementById("section-map-outline-container").firstChild.append(selectedPath);
    //                     if (!selectedSec.includes(path_ID)) {
    //                         setSelectedSec(prev => [...prev, path_ID]);
    //                         const idx = sections.indexOf(path_ID);
    //                         if (idx !== -1) {
    //                             setSecArea(prev => [...prev, idx]);
    //                         }
    //                     }
    //                     console.log(path_ID);
    //                 }

    //                 else if (!exact_match) {
    //                     const matchEle = container.querySelectorAll(`[id*="${temp_value}"]`);
    //                     const filteredPaths = Array.from(matchEle).filter(el => /[a-zA-Z]/.test(el.id));
    //                     let d;
    //                     let path_ID;

    //                     if (filteredPaths.length > 0) {
    //                         path_ID = filteredPaths[0].getAttribute('id');
    //                         d = filteredPaths[0].getAttribute('d');

    //                         console.log("Matched path:", path_ID);
    //                         console.log("Matched IDs with alphabet:", filteredPaths[0]);
    //                     }
    //                     else {
    //                         const filtered_Ele = Array.from(matchEle);

    //                         path_ID = filtered_Ele[0].getAttribute('id');
    //                         d = filtered_Ele[0].getAttribute('d');
    //                         console.log("Matched path:", path_ID);
    //                         console.log("Matched IDs:", filtered_Ele[0]);
    //                     }
    //                     const selectedPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
    //                     selectedPath.setAttribute("d", d);
    //                     selectedPath.setAttribute("fill", "rgba(99, 102, 241, 1)");
    //                     selectedPath.setAttribute("fill-rule", "evenodd");
    //                     selectedPath.setAttribute("class", "selected-sec");
    //                     selectedPath.setAttribute("data-sec", path_ID);
    //                     document.getElementById("section-map-outline-container").firstChild.append(selectedPath);
    //                     if (!selectedSec.includes(path_ID)) {
    //                         setSelectedSec(prev => [...prev, path_ID]);
    //                         const idx = sections.indexOf(path_ID);
    //                         if (idx !== -1) {
    //                             setSecArea(prev => [...prev, idx]);
    //                         }
    //                     }

    //                 }
    //             } else {
    //                 console.log("Already selected");
    //             }

    //         }
    //     }
    // }

    // const checker = (value) => {
    //     const container = document.getElementById('background-container');
    //     const all_path = container.querySelectorAll(`path[d^="${value}"]`);
    //     if (all_path.length > 0) {
    //         //return all_path;
    //         return Array.from(all_path);
    //     }
    //     else if (all_path.length == 0) {
    //         const container2 = document.getElementById("section-map-outline-container");
    //         value = value.replace(",", " ")
    //         const all_path2 = container2.querySelectorAll(`path[d^="${value}"]`);
    //         if (all_path2.length > 0) {
    //             //return all_path;
    //             return Array.from(all_path2);
    //         }
    //         else if (all_path2.length == 0) {
    //             const tempAll = container.querySelectorAll(`path[d^="${value}"]`);
    //             if (tempAll.length > 0) {
    //                 console.log(tempAll);
    //             }
    //         }
    //         else {
    //             return "fix value";
    //         }
    //     }
    //     else {
    //         return "fix value";
    //     }
    // }

    const handleSvgPathClick = (e) => {
        var stack = document.elementsFromPoint(e.clientX, e.clientY);

        for (var i = 0; i < stack.length; i++) {

            if (stack[i].id) {
                console.log(stack[i]);
                const tem_path = stack[i];
                const tem_path_ele = tem_path.getAttribute('d');
                const temp_raw_id = tem_path.getAttribute('id');
                const temp_path_id = temp_raw_id.includes('|||') ? temp_raw_id.split('|||')[1].trim() : temp_raw_id.trim();
                const svg = document.getElementById("section-map-outline-container").firstChild;
                const alreadyExists = svg.querySelector(`.selected-sec[data-sec="${temp_path_id}"]`);
                // const temp_path_class = tem_path.getAttribute('class')
                // var startValueTemp = Number(temp_path_id.split(' ')[0].split('M')[1]);
                if (['STAGE', 'POCHE', 'MIX', 'INACTIVE'].includes(temp_path_id) || !tem_path_ele) {
                    console.log('Invalid Path data.');
                    break;
                }
                else if (!sections.includes(temp_path_id)) {
                    console.log('Invalid section.')
                    break;
                }
                else if (alreadyExists) {
                    console.log('seciton already Exist');
                    break;
                }
                else {
                    const path_fill = document.createElementNS("http://www.w3.org/2000/svg", "path");
                    path_fill.setAttribute('d', tem_path_ele)
                    path_fill.setAttribute("fill", "rgba(99, 102, 241, 1)");
                    path_fill.setAttribute("fill-rule", "evenodd");
                    path_fill.setAttribute("class", "selected-sec");
                    path_fill.setAttribute("data-sec", temp_path_id);
                    document.getElementById("section-map-outline-container").firstChild.append(path_fill);
                    if (!selectedSec.includes(temp_path_id)) {
                        setSelectedSec(prev => [...prev, temp_path_id]);
                        const idx = sections.indexOf(temp_path_id);
                        if (idx !== -1) {
                            setSecArea(prev => [...prev, idx]);
                        }
                    }
                }
                break;
            }
        }
    };

    // Refs to coordinate progressive loading: apply saved filter when we have both details + filter
    const apiDataRef = useRef(null);
    const savedFilterRef = useRef(null);

    const applySavedFilterToState = (apiData, savedFilter) => {
        if (!savedFilter || !apiData) return;
        const allSections = Array.isArray(apiData.sectiondict)
            ? apiData.sectiondict
            : Object.values(apiData.sectiondict || []);
        const savedSections = (savedFilter.section || savedFilter.sect || savedFilter.sections || "")
            .toString()
            .split(",")
            .map(s => s.trim())
            .filter(Boolean);
        const savedArea = savedSections.map(sec => allSections.indexOf(sec)).filter(idx => idx !== -1);
        const savedMinSeats = savedFilter.MinDrpQty || savedFilter.Qty || "";
        let savedPrices = [];
        if (savedFilter.price && savedFilter.IsManually === "True") {
            setIsManual(true);
            savedPrices = savedFilter.price.toString().split(",").map(n => Number(n)).filter(n => !isNaN(n));
        } else {
            savedPrices = savedFilter.price.toString().split(",").map(n => Number(n)).filter(n => !isNaN(n));
        }
        setFilter([{
            sections: savedSections,
            area: savedArea,
            PriceRange: {
                min: savedPrices.length ? Math.min(...savedPrices) : "",
                max: savedPrices.length ? Math.max(...savedPrices) : ""
            },
            minSeats: savedMinSeats,
            ticketType: savedFilter.ticketType || ""
        }]);
        setSelectedSec([]);
        setSecArea([]);
        setMinSeats("");
        setSelectedType("");
        setMinPrice("");
        setMaxPrice("");
        setManualMinPrice("");
        setManualMaxPrice("");
    };

    const clearFilterState = () => {
        setFilter([]);
        setSelectedSec([]);
        setSecArea([]);
        setMinSeats("");
        setSelectedType("");
        setMinPrice("");
        setMaxPrice("");
        setManualMinPrice("");
        setManualMaxPrice("");
    };

    // Load event details, map, and saved filter when modal opens — show form as soon as details are in (progressive loading)
    useEffect(() => {
        if (!show || !eventMeta || Object.keys(eventMeta).length === 0) {
            setEventData({
                EventName: "",
                EventVenue: "",
                EventDate: "",
                EventLink: "",
                EventID: "",
                price: [],
                sections: [],
                ticketType: [],
                mapImage: "",
                EventInfoID: null,
                savedFilter: null,
            });
            clearFilterState();
            setSections([]);
            setSectionIndex([]);
            setTicketType([]);
            setPrice([]);
            setErrorMsg("");
            apiDataRef.current = null;
            savedFilterRef.current = null;
            return;
        }

        let mounted = true;
        const requestId = ++requestSeqRef.current;
        const start = (typeof performance !== "undefined" && performance.now) ? performance.now() : Date.now();
        const mark = (label, extra) => {
            const now = (typeof performance !== "undefined" && performance.now) ? performance.now() : Date.now();
            const ms = Math.round(now - start);
            if (extra !== undefined) {
                console.log(`[EventFilterModal:${requestId}] ${label}: ${ms}ms`, extra);
            } else {
                console.log(`[EventFilterModal:${requestId}] ${label}: ${ms}ms`);
            }
        };
        apiDataRef.current = null;
        savedFilterRef.current = null;

        const loadData = () => {
            setLoading(true);
            mark("open (Filter/Edit clicked)", { url: eventMeta?.EventLink, hasFilter, eventInfoId: eventMeta?.EventInfoID });

            const detailsPromise = eventMeta.EventLink
                ? fetchEventDetails(eventMeta.EventLink)
                : Promise.resolve(null);

            const mapPromise = eventMeta.EventLink
                ? (() => {
                    const match = eventMeta.EventLink.match(/event\/([^/?]+)/);
                    return match ? fetchEventMap(match[1]) : Promise.resolve(null);
                })()
                : Promise.resolve(null);

            const filterPromise =
                hasFilter && eventMeta.EventInfoID
                    ? GetUserDataForUpdate(eventMeta.EventInfoID)
                    : Promise.resolve(null);

            // Progressive: show form as soon as details arrive; map and filter fill in when ready
            detailsPromise
                .then((detailsResp) => {
                    if (!mounted) return;
                    mark("details resolved");
                    const apiData = detailsResp?.d || {};
                    apiDataRef.current = apiData;
                    let mapSvg = "";
                    const normalized = normalizeResponse(apiData, mapSvg, null, eventMeta.EventInfoID || null);
                    setEventData(normalized);
                    setSections(normalized.sections || []);
                    setSectionIndex(normalized.sections || []);
                    setTicketType(normalized.ticketType || []);
                    setPrice(normalized.price || []);
                    // No backend prices — enable manual price entry so user can set a range
                    setIsManual(!normalized.price?.length);
                    if (savedFilterRef.current) {
                        applySavedFilterToState(apiData, savedFilterRef.current);
                    } else {
                        clearFilterState();
                    }
                    setLoading(false);
                    mark("UI usable (after details)");
                })
                .catch((err) => {
                    console.error("Error loading event details:", err);
                    if (mounted) setLoading(false);
                });

            mapPromise
                .then((mapResp) => {
                    if (!mounted || !mapResp) return;
                    mark("map resolved");
                    const mapSvg = atob(mapResp).replace(/<\?xml.*?\?>/, "");
                    setEventData((prev) => ({ ...prev, mapImage: mapSvg }));
                })
                .catch((err) => console.warn("Map fetch failed:", err));

            filterPromise
                .then((filterResp) => {
                    if (!mounted) return;
                    mark("saved filter resolved");
                    const savedFilter = filterResp?.d?.[0] || null;
                    savedFilterRef.current = savedFilter;
                    const apiData = apiDataRef.current;
                    if (apiData && savedFilter) {
                        applySavedFilterToState(apiData, savedFilter);
                    } else if (!apiData) {
                        // details not in yet; detailsPromise.then will call applySavedFilterToState when it arrives
                    } else {
                        clearFilterState();
                    }
                })
                .catch((err) => {
                    console.warn("GetUserDataForUpdate failed:", err);
                    if (mounted) savedFilterRef.current = null;
                });
        };

        loadData();
        return () => { mounted = false; };
    }, [show, eventMeta, hasFilter]);

    //click on map
    const handleClick = (event) => {
        console.log("clicked");
        handleSvgPathClick(event);
    }

    // ADD FILTER
    const addFilter = () => {
        setErrorMsg("");
        if (selectedSec.length == 0) {
            setErrorMsg("Select The Section First.")
            return;
        }

        if (minSeats === "") {
            setErrorMsg("Select The Seat Qty First.");
            return;
        }
        const minN = Number(minPrice);
        const maxN = Number(maxPrice);
        if (!isManual) {
            if (minPrice === "" || maxPrice === "") {
                setErrorMsg("Select Both Min And Max Price");
                return;
            }
            if (isNaN(minN) || isNaN(maxN)) {
                setErrorMsg("Min and Max must be valid numbers.");
                return;
            }
            if (maxN < minN) {
                setErrorMsg("Max price must be greater than or equal to Min price.");
                return;
            }
        }


        if (isManual) {
            const manualMinN = Number(manualMinPrice);
            const manualMaxN = Number(manualMaxPrice);
            if (isNaN(manualMinN) || isNaN(manualMaxN)) {
                setErrorMsg("Enter Mix and Max Price Manually.");
                return;
            } else if (manualMaxN < manualMinN) {
                setErrorMsg("Max price must be greater than or equal to Min price.");
                return;
            }
        }

        const newFilter = {
            sections: selectedSec,
            area: secArea,
            ticketType: selectedType || "0",
            PriceRange: { min: manualMinPrice.toString() || minPrice.toString(), max: manualMaxPrice.toString() || maxPrice.toString() },
            minSeats
        };

        setFilter([newFilter]);

        // optional: clear the selection controls for UX
        setSelectedSec([]);
        setSecArea([]);
        setSelectedType("0");
        setMinPrice("");
        setMaxPrice("");
        setManualMinPrice("");
        setManualMaxPrice("");
        setMinSeats("");
        setErrorMsg("");
    };

    // SAVE FILTER (send to backend)
    const handleSaveFilter = async () => {
        // require eventData and at least one filter object
        if (!eventData || !eventData.EventLink || filter.length === 0) {
            setErrorMsg("No filter to save");
            return;
        }
        const currentFilter = filter[0];
        let normalizedSeats = currentFilter.minSeats;
        if (normalizedSeats !== undefined && normalizedSeats !== null && normalizedSeats !== "") {
            // Case 1: already number or numeric string ("1")
            if (!isNaN(normalizedSeats)) {
                normalizedSeats = String(normalizedSeats);
            }
            // Case 2: it's a label like "Single" or "Pair"
            else {
                for (let [num, label] of SeatsOptions.entries()) {
                    if (label.toLowerCase() === String(normalizedSeats).toLowerCase()) {
                        normalizedSeats = String(num);
                        break;
                    }
                }
            }
        } else {
            normalizedSeats = "";
        }

        const tempPrice = Array.isArray(eventData.price) && eventData.price.length
            ? eventData.price.map(Number).filter(p => !isNaN(p))
            : [];
        const minTempPrice = tempPrice.length ? Math.min(...tempPrice) : "";
        const maxTempPrice = tempPrice.length ? Math.max(...tempPrice) : "";
        const isManually = isManual;

        const filterDetails = {
            eventurl: eventData.EventLink,
            ticketType: currentFilter.ticketType || "",
            priceFrom: isManually ? minTempPrice.toString() : currentFilter.PriceRange?.min?.toString() || "",
            priceTo: isManually ? maxTempPrice.toString() : currentFilter.PriceRange?.max?.toString() || "",
            price: (eventData.price || []).join(","),
            sect: (currentFilter.sections || []).join(","), // no trailing comma
            area: (currentFilter.area || []).join(","),
            Qty: normalizedSeats, //currentFilter.minSeats?.toString() || "",
            eventname: eventData.EventName || "",
            eventID: eventData.EventID || "",
            eventInfoID: eventData.EventInfoID || "",
            eventvenue: eventData.EventVenue || "",
            eventdate: eventData.EventDate || "",
            Minrange: isManual ? currentFilter.PriceRange?.min?.toString() : manualMinPrice.toString() || "",
            Maxrange: isManual ? currentFilter.PriceRange?.max?.toString() : manualMaxPrice.toString() || ""
        };


        try {
            setLoading(true);
            //let response;
            if (hasFilter && isManual) {
                const filterDatastr = `{eventurl:\"${filterDetails.eventurl}\",ticketType:\"${filterDetails.ticketType}\",priceFrom:\"${filterDetails.priceFrom}\",priceTo:\"${filterDetails.priceTo}\",price:\"${filterDetails.price}\",sect:\"${filterDetails.sect}\",area:\"${filterDetails.area}\",Qty:\"${filterDetails.Qty}\",eventname:\"${filterDetails.eventname}\",eventvenue:\"${filterDetails.eventvenue}\",eventdate:\"${filterDetails.eventdate}\",Minrange:\"${filterDetails.Minrange}\",Maxrange:\"${filterDetails.Maxrange}\",EventID:\"${filterDetails.eventInfoID}\",ManuallyPrice:"True"}`

                const response = await updateFilterDetails(filterDatastr);
                if (response.d == 'Success') {
                    onApplyFilter(filterDetails.eventurl, filterDetails);
                    onHide();
                }
            } else if (hasFilter && !isManual) {
                const filterDatastr = `{eventurl:\"${filterDetails.eventurl}\",ticketType:\"${filterDetails.ticketType}\",priceFrom:\"${filterDetails.priceFrom}\",priceTo:\"${filterDetails.priceTo}\",price:\"${filterDetails.price}\",sect:\"${filterDetails.sect}\",area:\"${filterDetails.area}\",Qty:\"${filterDetails.Qty}\",eventname:\"${filterDetails.eventname}\",eventvenue:\"${filterDetails.eventvenue}\",eventdate:\"${filterDetails.eventdate}\",Minrange:\"${filterDetails.Minrange}\",Maxrange:\"${filterDetails.Maxrange}\",EventID:\"${filterDetails.eventInfoID}\",ManuallyPrice:"false"}`

                const response = await updateFilterDetails(filterDatastr);
                if (response.d == 'Success') {
                    onApplyFilter(filterDetails.eventurl, filterDetails);
                    onHide();
                }
            }
            else {
                const filterDatastr = `{eventurl:\"${filterDetails.eventurl}\",ticketType:\"${filterDetails.ticketType}\",priceFrom:\"${filterDetails.priceFrom}\",priceTo:\"${filterDetails.priceTo}\",price:\"${filterDetails.price}\",sect:\"${filterDetails.sect}\",area:\"${filterDetails.area}\",Qty:\"${filterDetails.Qty}\",eventname:\"${filterDetails.eventname}\",eventvenue:\"${filterDetails.eventvenue}\",eventdate:\"${filterDetails.eventdate}\",Minrange:\"${filterDetails.Minrange}\",Maxrange:\"${filterDetails.Maxrange}\",ManuallyPrice:"True"}`

                const response = await saveFilterDetails(filterDatastr);
                const regex = /^\{"d":"\d+-\d+"\}$/;
                if (regex.test(response) || response) {
                    onApplyFilter(filterDetails.eventurl, filterDetails);
                    onHide();
                    // PopulateEventData();
                    // window.location.reload();
                }
                else {
                    setErrorMsg("Failed to save filter. Please try again.");
                }
            }
        } catch (err) {
            console.error("saveFilterDetails error:", err);
            setErrorMsg("Error to save filter. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    // --- Helpers for section selection ---
    const handleSelectSection = (value) => {
        if (!value) return;
        if (!selectedSec.includes(value)) {
            const svg = document.getElementById("map-img").getElementsByTagName("svg")[0];
            if (!svg) return;
            const selectedPath = svg.getElementById(`${value}`);
            if (!selectedPath) {
                setSelectedSec(prev => [...prev, value]);
                const idx = sections.indexOf(value);
                if (idx !== -1) {
                    setSecArea(prev => [...prev, idx]);
                }
                setSelectedDropdown("");
                return;
            }
            const target_d = selectedPath.getAttribute("d");
            const attribute_d = target_d.replaceAll(',', ' ').replaceAll('L', ' L').replaceAll('Z', ' Z');
            const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
            path.setAttribute("d", attribute_d);
            path.setAttribute("fill", "rgba(99, 102, 241, 1)");
            path.setAttribute("fill-rule", "evenodd");
            path.setAttribute("class", "selected-sec");
            path.setAttribute("data-sec", value);
            document.getElementById("section-map-outline-container").firstChild.append(path);

            setSelectedSec(prev => [...prev, value]);
            const idx = sections.indexOf(value);
            if (idx !== -1) {
                setSecArea(prev => [...prev, idx]);
            }
        }
        setSelectedDropdown("");
    };

    const handleSelectAllSections = () => {
        if (!sections || sections.length === 0) return;
        if (selectedSec.length === sections.length) {
            document
                .querySelectorAll(".selected-sec")
                .forEach(el => el.remove());

            setSelectedSec([]);
            setSecArea([]);
            setSelectedDropdown("");
            return;
        }

        const svg = document.getElementById("map-img")?.getElementsByTagName("svg")[0];
        const container = document.getElementById("section-map-outline-container")?.firstChild;
        if (!svg || !container) return;

        let allIndexes = [];

        sections.forEach((value, index) => {
            // Skip if already selected
            if (selectedSec.includes(value)) {
                allIndexes.push(index);
                return;
            }

            const selectedPath = svg.getElementById(`${value}`);

            if (!selectedPath) {
                allIndexes.push(index);
                return;
            }

            const target_d = selectedPath.getAttribute("d");
            if (!target_d) return;

            const attribute_d = target_d
                .replaceAll(',', ' ')
                .replaceAll('L', ' L')
                .replaceAll('Z', ' Z');

            const path = document.createElementNS(
                "http://www.w3.org/2000/svg",
                "path"
            );

            path.setAttribute("d", attribute_d);
            path.setAttribute("fill", "rgba(99, 102, 241, 1)");
            path.setAttribute("fill-rule", "evenodd");
            path.setAttribute("class", "selected-sec");
            path.setAttribute("data-sec", value);

            container.append(path);

            allIndexes.push(index);
        });

        setSelectedSec([...sections]);
        setSecArea(allIndexes);
        setSelectedDropdown("");
    };

    // --- Render ---
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="xl"
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header className="border-0">
                <div className="w-100 px-3">
                    <div className="d-flex justify-content-between align-items-center text-center">
                        <div>
                            <div style={{ fontSize: 14 }}>
                                <strong>Date: </strong>
                                <span>{eventData.EventDate || "N/A"}</span>
                            </div>
                        </div>

                        <div>
                            <div style={{ fontSize: 16 }}>
                                <strong>Name:</strong>{" "}
                                <span>{eventData.EventName || ""}</span>
                            </div>
                            <div style={{ fontSize: 14, marginTop: 4 }}>
                                <strong>Price Range:</strong>{" "}
                                <span>
                                    {Array.isArray(eventData.price) && eventData.price.length
                                        ? `$${Math.min(...eventData.price)} - $${Math.max(...eventData.price)}`
                                        : "N/A"}
                                </span>
                            </div>
                        </div>

                        <div>
                            <div style={{ fontSize: 14 }}>
                                <strong>Venue:</strong>{" "}
                                <span>{eventData.EventVenue || ""}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Header>

            <Modal.Body style={{ minHeight: 240, position: "relative" }}>
                {loading ? (
                    // Centered loader inside modal body
                    <div style={{ position: "absolute", left: "50%", top: "50%", transform: "translate(-50%,-50%)" }}>
                        <ScreenLoading />
                    </div>
                ) : (
                    <Row className="g-2">
                        {/* LEFT: filters */}
                        <Col lg={7}>
                            <div className="p-3 mb-3 filter-box">
                                <Row className="g-1 align-items-center">
                                    <Col md={2} sm={6}>
                                        <p>Sections</p>
                                        <Form.Select
                                            value={selectedDropdown}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setSelectedDropdown(value);
                                                if (value === "All") {
                                                    handleSelectAllSections();
                                                } else {
                                                    handleSelectSection(value);
                                                }
                                            }}
                                            aria-label="Sections" id="sectionSelect"
                                        >
                                            <option value="">Select</option>
                                            <option value="All">Select All</option>
                                            {sections.map((section, index) => (
                                                <option key={index} value={section}>
                                                    {section}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Col>

                                    <Col md={4} sm={6}>
                                        <p>Price</p>
                                        <div className="d-flex justify-content-center align-item-center">
                                            <Form.Select className="me-1"
                                                value={minPrice}
                                                disabled={isManual}
                                                onChange={(e) => {
                                                    setMinPrice(e.target.value);
                                                    setMaxPrice("");
                                                }}
                                                aria-label="minPrice"
                                            >
                                                <option value="">Min Price</option>
                                                {price.map((pmin, i) => (
                                                    <option key={i} value={pmin.toString()}>
                                                        {pmin}
                                                    </option>
                                                ))}
                                            </Form.Select>

                                            <Form.Select
                                                value={maxPrice}
                                                onChange={(e) => setMaxPrice(e.target.value)}
                                                disabled={!minPrice || isManual}
                                                aria-label="maxPrice"
                                            >
                                                <option value="">Max Price</option>
                                                {price
                                                    .filter((pmax) => Number(pmax) >= Number(minPrice))
                                                    .map((pmax, i) => (
                                                        <option key={i} value={pmax.toString()}>
                                                            {pmax}
                                                        </option>
                                                    ))}
                                            </Form.Select>
                                        </div>
                                    </Col>

                                    <Col md={3} sm={6}>
                                        <p>Min Seats</p>
                                        <Form.Select
                                            value={minSeats}
                                            onChange={(e) => setMinSeats(e.target.value)}
                                            aria-label="Min seats"
                                        >
                                            <option value="">Seats</option>
                                            {[...SeatsOptions.entries()].map(([num, label]) => (
                                                <option key={num} value={num}>
                                                    {label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Col>

                                    <Col md={3} sm={12}>
                                        <p>Ticket Types</p>
                                        <Form.Select
                                            value={selectedType}
                                            onChange={(e) => setSelectedType(e.target.value)}
                                            aria-label="Ticket Types"
                                        >
                                            <option value="0">Any</option>
                                            {ticketType.map((type, index) => (
                                                <option key={index} value={type}>
                                                    {type}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <div className=" mt-2">
                                            <div className="d-flex justify-content-start align-items-center">
                                                <input className='form-check-input me-1' type="checkbox" id="priceManual" style={{ width: '1em', height: '1em' }} checked={isManual}
                                                    onChange={(e) => {
                                                        const checked = e.target.checked;
                                                        setIsManual(checked);
                                                        // if (checked) {
                                                        //     setMinPrice("");
                                                        //     setMaxPrice("");
                                                        // } else {
                                                        //     setManualMinPrice("");
                                                        //     setManualMaxPrice("");
                                                        // }

                                                    }} />
                                                <p>Enter Price Manually</p>
                                            </div>
                                            <div className="d-flex justify-content-start align-items-center mt-1">
                                                <div className="me-2">
                                                    {/* <label htmlFor="">Min Price Range</label> */}
                                                    <input className="form-control" type="text" placeholder="Min Range optional" disabled={!isManual} value={manualMinPrice} onChange={(e) => { setManualMinPrice(e.target.value) }} />
                                                </div>
                                                <div>
                                                    {/* <label htmlFor="">Max Price Range</label> */}
                                                    <input className="form-control" type="text" placeholder="Max Range optional" disabled={!isManual} value={manualMaxPrice} onChange={(e) => { setManualMaxPrice(e.target.value) }} />
                                                </div>
                                                <div className="text-center ms-3">
                                                    <button className="btn btn-custom" onClick={addFilter}>
                                                        <strong>+</strong> Add Filter
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                {errorMsg && (
                                    <div style={{ color: "red", marginBottom: "10px" }}>{errorMsg}</div>
                                )}

                            </div>

                            {/* Selected sections */}
                            {selectedSec.length !== 0 &&
                                <Row className="g-1">
                                    <Col md={12}>
                                        <div className="p-3 mb-3 selected-sections filter-box" >
                                            <h6>Selected Sections:</h6>
                                            {selectedSec.length === 0 && <p style={{ fontSize: "14px" }}>Sections empty</p>}

                                            {selectedSec.map((section, index) => (
                                                <span key={index} className="badge bg-primary p-2 me-1 mt-1">
                                                    {section}
                                                    <span
                                                        style={{ marginLeft: 8, cursor: "pointer", fontWeight: "bold", color: "white" }}
                                                        onClick={() => {
                                                            const updated = [...selectedSec];
                                                            updated.splice(index, 1);
                                                            setSelectedSec(updated);
                                                            const updatedArea = [...secArea];
                                                            updatedArea.splice(index, 1);
                                                            setSecArea(updatedArea);

                                                            const svg = document.getElementById("map-img").getElementsByTagName("svg")[0];
                                                            if (!svg) return;
                                                            const pathToRemove = svg.querySelector(`.selected-sec[data-sec="${section}"]`);
                                                            if (pathToRemove) {
                                                                pathToRemove.remove();
                                                                console.log(pathToRemove);
                                                            }
                                                            //pathToRemove.setAttribute('fill', 'none');
                                                        }}
                                                    >
                                                        ×
                                                    </span>
                                                </span>
                                            ))}
                                        </div>
                                    </Col>
                                </Row>
                            }


                            {/* Applied filters */}
                            <Row className="g-1">
                                <Col md={12}>
                                    <div className="p-3 mb-3 applied-filters filter-box">
                                        <h6>Applied Filters:</h6>
                                        {filter.length === 0 && <p style={{ fontSize: "14px" }}>No filters</p>}
                                        {filter.map((f, index) => (
                                            <div
                                                key={index}
                                                className="p-2 mb-2 d-flex justify-content-between align-items-start"
                                                style={{ border: "1px solid #ddd", borderRadius: 6 }}
                                            >
                                                <div>
                                                    <strong>Sections:</strong> {f.sections.join(", ")} <br />
                                                    <strong>Price Range:</strong> ${f.PriceRange.min} - ${f.PriceRange.max} <br />
                                                    <strong>Min Seats:</strong> {SeatsOptions.get(Number(f.minSeats)) || f.minSeats || ""} <br />
                                                    {/* {f.minSeats || "N/A"} */}
                                                    <strong>Ticket Types:</strong> {f.ticketType === "0" || !f.ticketType ? "Any" : f.ticketType}
                                                </div>

                                                <span
                                                    style={{ cursor: "pointer", color: "red", fontSize: 22, marginLeft: 10, fontWeight: "bold" }}
                                                    onClick={() => {
                                                        // Remove this filter
                                                        const updatedFilter = [...filter];
                                                        updatedFilter.splice(index, 1);
                                                        setFilter(updatedFilter);

                                                        // Remove corresponding selected sections and areas
                                                        const updatedSelectedSec = selectedSec.filter(
                                                            s => !f.sections.includes(s)
                                                        );
                                                        setSelectedSec(updatedSelectedSec);

                                                        const updatedSecArea = secArea.filter(
                                                            (_, idx) => !f.sections.includes(selectedSec[idx])
                                                        );
                                                        setSecArea(updatedSecArea);

                                                        // Remove corresponding SVG paths
                                                        const svg = document.getElementById("map-img")?.getElementsByTagName("svg")[0];
                                                        if (svg) {
                                                            f.sections.forEach(section => {
                                                                const pathToRemove = svg.querySelector(`.selected-sec[data-sec="${section}"]`);
                                                                if (pathToRemove) pathToRemove.remove();
                                                            });
                                                        }
                                                    }}
                                                >
                                                    ×
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </Col>
                            </Row>
                        </Col>

                        {/* RIGHT: seating map */}
                        <Col lg={5}>
                            <div className="p-1 filter-box-map" >
                                <div className="d-flex justify-content-center mb-3">
                                    <div id="map-img" dangerouslySetInnerHTML={{ __html: eventData.mapImage || "" }} onClick={handleClick} />

                                </div>
                            </div>
                        </Col>
                    </Row>
                )}
            </Modal.Body>

            <Modal.Footer className="border-0 filter-footer">
                <button className="btn btn-outline" size="sm" onClick={onHide} >
                    Close
                </button>
                <button className="btn btn-custom" onClick={handleSaveFilter} disabled={loading || filter.length === 0}>
                    Save Filter
                </button>
            </Modal.Footer>
        </Modal>
    );
}
